export const clientLogoCustom = `
  <img
    id="client_logo"
    class="client-logo-custom"
    src="{{ client.logo | to_presigned_url }}"
  />
`;